import React from 'react';
import {connect} from 'react-redux';
import {Flex, TextInput} from '/app/src/component';

const labelStyle = {
    fontSize: '18px',
    paddingLeft: '5px',
    marginBottom: '3px'
}

const errorMsgStyle = {
    position: 'absolute',
    color: 'red',
    fontSize: '12px',
    marginLeft: '4px'

}
const errorMsgWrapper = {
    position: 'relative'
}


class PaymentInfoInput extends React.Component {
    render() {
        const {label, placeholder, onChange, value, errorMsg} = this.props
        return (
            <Flex column width='100%'>
                <Flex {...labelStyle}>{label}</Flex>
                <Flex>
                    <TextInput
                        placeholder={placeholder}
                        fontSize='16px'
                        onChange={onChange}
                        value={value}/>
                </Flex>
                <Flex {...errorMsgWrapper}>
                    <Flex {...errorMsgStyle}>
                        {errorMsg}
                    </Flex>
                </Flex>
            </Flex>
        )
    }
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps, null)(PaymentInfoInput);



// WEBPACK FOOTER //
// ./src/component/Modal/PaymentModal/PaymentInfoInput.js